import axios from "axios";
import CryptoJS from "crypto-js";

import { some } from "constants/constants";
import { configs } from "./config";

const request = axios.create();

request.interceptors.request.use(
  (config: some) => {
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

const getBaseUrl = (severVice = "") => {
  switch (severVice) {
    case "apis":
      return configs().APIS_URL;
    default:
      return configs().BASE_URL;
  }
};

export const DEV = process.env.NODE_ENV === "development";
export const APP_KEY = DEV
  ? ":740fa3ca-6a14-4863-8589-f3926417a6701"
  : ":akxmnn1ikajkj123mzxasrqana";
export const VERSION = "1.0";
export const APP_ID = DEV ? "partner_web" : "com.tripi.partner";

const api = (options: some, severVice?: string) => {
  let timestamp = new Date().getTime();
  timestamp = timestamp / 1000 - ((timestamp / 1000) % 300);
  const str = timestamp + APP_KEY;
  const hashStr = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(str));
  return request({
    baseURL: getBaseUrl(severVice),
    ...options,
    headers: {
      "Accept-Language": "vi",
      version: "1.0",
      appHash: hashStr,
      appId: APP_ID,
      ...options.headers,
    },
  });
};

export default api;
